import { useEffect } from "react";
import { BottomNav } from "../../../components/Nav/BottomNav";
import { Wallet } from "../../../components/Wallet";
import { InvestCard1 } from "../../../components/Cards/InvestCard";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  getLogUserRequest,
  getPlansRequest,
  getUserInvestmentsRequest,
} from "../../../redux/action";
import { CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { BsWhatsapp } from "react-icons/bs";

const Home = () => {
  const dispatch = useDispatch();

  const { history } = useHistory();

  const {
    getPlansError,
    getPlansLoading,
    user,
    isLoggedIn,
    plans,
    getLogUserError,
    token,
    getUserInvestmentsError,
  } = useSelector((state) => {
    const {
      success: { getPlans: getPlansSuccess },
      errors: {
        getPlans: getPlansError,
        getUserInvestments: getUserInvestmentsError,
        getLogUser: getLogUserError,
      },
    } = state.ajaxStatuses;

    const { getUserInvestmentsLoading, getPlansLoading, getLogUserLoading } =
      state.loadingIndicator;

    const { user, token, isLoggedIn } = state.userData;

    const { investments } = state.investmentData;

    const { plans } = state.planData;

    return {
      getPlansSuccess,
      getPlansError,
      getPlansLoading,
      user,
      isLoggedIn,
      plans,
      getLogUserError,
      token,
      getLogUserLoading,
      getUserInvestmentsLoading,
      investments,
      getUserInvestmentsError,
    };
  });

  useEffect(() => {
    if (!isLoggedIn) {
      history.push("/login");
    }
  }, [isLoggedIn]);
  useEffect(() => {
    if (getPlansError) {
      toast.error(getPlansError, {
        duration: 3000,
      });
    }
  }, [getPlansError]);

  useEffect(() => {
    if (getLogUserError) {
      toast.error(getLogUserError, {
        duration: 3000,
      });
    }
  }, [getLogUserError]);

  useEffect(() => {
    dispatch(getPlansRequest());

    dispatch(getLogUserRequest(token));
  }, [getPlansRequest]);

  useEffect(() => {
    dispatch(getUserInvestmentsRequest(user._id));

    dispatch(getLogUserRequest(token));
  }, [getUserInvestmentsRequest]);

  useEffect(() => {
    if (getUserInvestmentsError) {
      toast.error(getUserInvestmentsError, {
        duration: 3000,
      });
    }
  }, [getUserInvestmentsError]);

  const imgArray = [
    "/img/new/card/1.jpg",
    "/img/new/card/2.jpg",
    "/img/new/card/3.jpg",
    "/img/new/card/4.jpg",
    "/img/new/card/2.jpg",
    "/img/new/card/3.jpg",
  ];

  return (
    <div>
      <div className="container max-w-sm mx-auto relative h-screen overflow-y-scroll pb-8">
        <div className="relative pb-3">
          <div className="relative">
            {" "}
            <h4 className="font-body text-lg  px-4 pt-8 pb-2 font-bold">
              MecGlobal
            </h4>
            <p className="text-gray-700 text-sm font-body px-4">
              Mecglobal is a Canada located company before they move to
              Australia where they operate crypto investment. The company is
              into trading, mining, technology and manufacturing which generate
              good and enough money for profit and income
            </p>
            <a
              href="https://wa.me/66941321783"
              className="text-white flex justify-center gap-x-2  items-center text-sm bg-green-500 mx-4 mt-3 py-2 px-2 rounded-3xl text-center w-[105px]"
            >
              Contact
              <BsWhatsapp />
            </a>
          </div>
        </div>

        <div className="px-4 ">
          <Wallet user={user} isHome={true} />

          <div className="mb-[100px] mt-10">
            <div className="text-xl font-body font-medium">
              Get Started Investing
            </div>

            <div className="mt-10">
              {getPlansLoading ? (
                <div className="h-[20vh] flex items-center justify-center text-center">
                  <CircularProgress size={20} className="text-primary" />
                </div>
              ) : (
                <div className="grid grid-cols-2 mt-10 gap-3">
                  {plans.map((plan, index) => (
                    <InvestCard1
                      plan={plan}
                      key={index}
                      img={imgArray[index]}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className=" max-w-sm mx-auto w-full ">
        <BottomNav />
      </div>
    </div>
  );
};

export default Home;
